import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { map } from 'rxjs/operators';
import { StudentService } from 'src/app/providers/student/student.service';
import { DataService } from 'src/app/providers/data.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-student-modal',
  templateUrl: './student-modal.component.html',
  styleUrls: ['./student-modal.component.scss'],
  providers: [DataService]
})
export class StudentModalComponent implements OnInit {
  studentForm: FormGroup;

  local_data: any;
  id: number;
  firstname: string;
  lastname: string;
  studentid: number;
  phone: number;
  email: string;
  item:[];
  count:number;

  public dataClassList$: Observable<[]>;
 

  constructor(public fb: FormBuilder,
    public dialogRef: MatDialogRef<StudentModalComponent>,
    private studentService: StudentService,  public dataService: DataService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.local_data = { ...data };
    this.id = this.local_data.id;
    if (!this.id) {
      this.createForm();
    } else {
      this.editForm();
    }
  }

  ngOnInit(): void {
    //class list
    this.dataClassList$ = this.dataService.ClassList;
    this.dataService.getClassData().subscribe();

    this.dataClassList$.subscribe(result => {this.item = result});
  }

  createForm() {
    this.studentForm = new FormGroup({
      firstname: new FormControl(),
      lastname: new FormControl(),
      studentid: new FormControl(),
      phone: new FormControl(),
      email: new FormControl()
    });

    this.studentForm = this.fb.group({
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      studentid: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      email: ['', [Validators.required]],
      //studentClasses: ['', [Validators.required]]
    })
    //this.addStudentClass();
  }

  editForm() {
    this.studentForm = new FormGroup({
      firstname: new FormControl(),
      lastname: new FormControl(),
      studentid: new FormControl(),
      phone: new FormControl(),
      email: new FormControl()
    });

    this.studentForm = this.fb.group({
      firstname: [this.data.firstname, [Validators.required]],
      lastname: [this.data.lastname, [Validators.required]],
      studentid: [this.data.studentid, [Validators.required]],
      phone: [this.data.phone, [Validators.required]],
      email: [this.data.email, [Validators.required]],
      //studentclasses: ['', [Validators.required]]
    })
  }

  studentClasses(): FormArray {
    return this.studentForm.get("studentClasses") as FormArray;
  }

  newStudentClass(): FormGroup {
    return this.fb.group({
      Class_SysRef: new FormControl()
    })
  }
  addStudentClass() {
    this.studentClasses().push(this.newStudentClass());
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  addStudent() {
    if (!this.id) {
      console.log(this.studentForm.value);
      this.studentService.addStudent(this.studentForm.value)
        .pipe(map(
          data => { return data },
          err => { console.log(err); return err }
        ))
        .subscribe(
          data => {
            return data;
          },
          err => { alert("Invalid data"); console.log(err) }
        );
    } else {
      console.log(this.studentForm.value);
      this.studentService.editStudent(this.id, this.studentForm.value)
        .pipe(map(
          data => { return data },
          err => { console.log(err); return err }
        ))
        .subscribe(
          data => {
            return data;
          },
          err => { alert("Invalid data"); console.log(err) }
        );
    }
  }

}
